import { useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SavedPromptsIcon from '../../assets/icon-saved-prompts.svg?react';
import ToolIconLeft from '@/assets/icon-tool-left.svg?react';
import ToolIconRight from '@/assets/icon-tool-right.svg?react';
import PromptHelperIcon from '@/assets/icon-prompt-helper.svg?react';
import useElysiaStore from '@/app/elysia-store';
const ToolsDropdown = ({ onInitiatedSavedPrompts, onInitiatedPromptHelper }) => {
  const [show, setShow] = useState(false);
  const handleToggle = () => {
    setShow(!show);
  };
  const isPrivateChat = useElysiaStore((state) => state.isPrivateChat);
  const promptToolsConfig = useElysiaStore((state) => state.promptToolsConfig);

  return (
    <>
      <Dropdown show={show} onToggle={handleToggle} drop="up">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip className="tooltip-sidebar">Tools</Tooltip>}
          trigger={['hover', 'focus']}
        >
          <Dropdown.Toggle
            variant="light"
            id="chat-widget-dropdown"
            className={`tool-icon`}
            aria-label="Tools"
          >
            <div className="d-flex justify-content-center align-items-center gap-1">
              <ToolIconLeft />
              <ToolIconRight />
            </div>
          </Dropdown.Toggle>
        </OverlayTrigger>

        <Dropdown.Menu className="tools-dropdown">
          {!isPrivateChat && promptToolsConfig.promptImprover && (
            <Dropdown.Item
              as="button"
              onClick={onInitiatedPromptHelper}
              aria-label="Prompt Improver"
            >
              <PromptHelperIcon />
              Prompt Improver
            </Dropdown.Item>
          )}
          {!isPrivateChat && (
            <Dropdown.Item as="button" onClick={onInitiatedSavedPrompts} aria-label="Saved prompts">
              <SavedPromptsIcon />
              Saved prompts
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default ToolsDropdown;
